import {
    ITagRequestAction,
    IUpdateStateAction,
    updateState,
    continueTagRequest,
} from "../actions/tagRequestActions";
import {IItem, ITagRequestProps, TagRequestActions} from "../types";

const initialState: Partial<ITagRequestProps> = {
    tagRequest: {} as IItem,
    currentItemId: null,
};

export default function (state = initialState, action: ITagRequestAction): ITagRequestProps {
    switch (action.type) {

        //====================================================================
        // Map Actions messages to Action functions
        //====================================================================

        case TagRequestActions.StoreTagRequestProps:       return updateState(state, action as IUpdateStateAction);
        case TagRequestActions.UpdateState:                return updateState(state, action as IUpdateStateAction);
        case TagRequestActions.Continue:                   return continueTagRequest(state);
        default:
            return state as ITagRequestProps;
    }
}

